<template>
  <div class="active-home">
    <com-returntop></com-returntop>
    <img
      class="active-banner"
      src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/about/about2.png"
      alt
    />
    <div class="active-top">
      <div class="active-top-box">
        <img
          src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/active/active6.png"
          class="active-top-box-img"
          alt
        />
        <div v-for="(item, index) in titleList" :key="index">
          <img
            v-show="index !== 0"
            src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/active/active5.png"
            alt
          />
          <span>{{ item }}</span>
        </div>
      </div>
    </div>
    <div class="active-bottom">
      <div class="active-bottom-menu">
        <img
          src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/active/active21.png"
          alt
        />
        <h1>公司动态</h1>
        <p>News</p>
        <div></div>
      </div>
      <div class="active-bottom-right">
        <div class="titleList">
          <div
            class="title"
            v-for="(item, index) in newsList"
            :key="index"
            @mouseenter="enter(index)"
            @mouseleave="leave()"
            @click="toDetail(index)"
          >
            <div :class="styleFlag == index ? 'title-left2' : 'title-left1'">
              {{ item.tm.Y }}.{{ item.tm.M }}.{{ item.tm.D }}
            </div>
            <div class="title-right">
              <div class="title-title">{{ item.name }}</div>
              <div class="title-brief">{{ item.brief }}</div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="title-page">
          <!-- 如果只有一页 不显示页码及下一页 -->
          <!-- <div v-if="page.pageCount>1"> -->
          <div class="flex">
            <div
              v-for="index of page.pageCount"
              class="box"
              :class="pageIndex == index ? 'active' : ''"
              @click="pagetap(index)"
            >{{index}}</div>
          </div>
          <div class="box title-page-active" @click="pageto()" style="width: 150px;">下一页</div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import comReturntop from "@/components/returntop";
import { Article, timestampToTime } from "./../services/article";
export default {
  components: {
    comReturntop,
  },
  data() {
    return {
      pindex: 0,
      pageIndex: 1,
      styleFlag: -1,
      newsList: [],
      titleList: ["首页", "公司动态"],
      html: "",
      html1: "",
      name: "",
      tm: {
        Y: "",
        M: "",
        D: "",
      },
      c1: {
        id: "",
        name: "",
        tm: {
          Y: "",
          M: "",
          D: "",
        },
      },
      c2: {
        id: "",
        name: "",
        tm: {
          Y: "",
          M: "",
          D: "",
        },
      },
      page: {
        totalCount: 0, //总记录数
        pageCount: 1, //总页数
        currentPage: 0, //当前页
        perPage: 10, //每页显示数量
      },
    };
  },
  mounted() {
    // this.getList();
    // this.getList(this.$route.query.id);
    this.article();
  },
  watch: {},
  methods: {
    // getList(id) {
    //   document.body.scrollTop = 0;
    //   document.documentElement.scrollTop = 0;
    //   let newsList = [];
    //   this.newsList = [];
    //   Article({ category_id: 80 }).then((res1) => {
    //     if (res1.items.length > 0) {
    //       this.dataList = [];
    //       res1.items.forEach((item) => {
    //         dataList.push(item);
    //       });
    //       //这里接口跨域，this.dataList获取不到值
    //       this.dataList = dataList;
    //       //console.log(dataList, "dataList");
    //       let cid = this.dataList[0].id;
    //       //获取二级分类下的文章列表
    //       if (index != 2) {
    //         this.article(cid, 1);
    //       }
    //     }
    //   });
    // },
    article(cid,page) {
      let newsList = [];
      this.newsList = [];
      Article({
        category_id: 80,
        pageSize: 10,
        top: -1,
        page: page,
      }).then((res2) => {
        if (res2.items.length > 0) {
          res2.items.forEach((citem) => {
            //时间格式处理   原有逻辑↓
            //let tm = timestampToTime(citem.release_time);
            //适配java后端需要做时间转换
            let tm = timestampToTime(
              new Date(citem.release_time).getTime() / 1000
            );
            citem.tm = tm;
            newsList.push(citem);
          });
          this.newsList = newsList;
          //处理分页
          this.page.totalCount = res2._meta.totalCount;
          this.page.pageCount = res2._meta.pageCount;
          this.page.currentPage = res2._meta.currentPage;
        }
      });
    },
    //鼠标悬浮事件-修改文章标题样式
    enter(index) {
      this.styleFlag = index;
    },
    //鼠标离开事件-修改文章标题样式
    leave() {
      this.styleFlag = -1;
    },
    // 文章点击跳转文章详情页
    toDetail(index) {
      // if (this.newsList[index].content.length < 100) {
      //   window.open(this.newsList[index].attachment, "_blank");
      //   return;
      // }
      this.$router.push({
        path: "/certificate-active",
        query: {
          id: this.newsList[index].id,
          category_id: this.newsList[index].category_id,
        },
      });
    },
    // 翻页方法
    pagetap(page) {
      let cid = 0;
      this.pageIndex = page; //更新页码样式控制参数
      if (this.activeName == 2) {
        cid = this.menuList[2].id;
      } else {
        // cid = this.dataList[this.pindex].id;
      }
      this.article(cid, page);
    },
    pageto() {
      let cid = 0;
      //更新页码样式控制参数
      if (this.pageIndex == this.page.pageCount) {
        this.pageIndex = 1;
      } else {
        this.pageIndex = this.pageIndex + 1;
      }
      //获取cid
      if (this.activeName == 2) {
        cid = this.menuList[2].id;
      } else {
        // cid = this.dataList[this.pindex].id;
      }
      this.article(cid, this.pageIndex);
    },
  },
};
</script>
<style scoped>
.active-home {
  padding-bottom: 80px;
}
.active-banner {
  width: 100%;
  height: 450px;
}
.active-top {
  width: 100%;
  height: 90px;
  background: #eee;
}
.active-top-box {
  width: 1200px;
  margin: 0 auto;
  height: 90px;
  display: flex;
  align-items: center;
}
.active-top-box div {
  font-size: 14px;
  color: #999;
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.active-top-box div img {
  width: 6px;
  height: 6px;
  margin-right: 20px;
}
.active-top-box-img {
  width: 12px;
  height: 12px;
  margin-right: 14px;
}
.active-bottom {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.active-bottom-menu {
  width: 330px;
  height: 640px;
  background: url("http://bernouly.oss-cn-beijing.aliyuncs.com/images/active/active1.png")
    center no-repeat;
  background-size: 100% 100%;
  position: relative;
  padding: 50px 30px;
}
.active-bottom-right {
  width: 760px;
  margin-top: 40px;
}
.active-bottom-menu img {
  width: 88px;
  height: 88px;
}
.active-bottom-menu h1 {
  font-size: 48px;
  color: #fff;
  margin-top: 22px;
  font-weight: bold;
}
.active-bottom-menu p {
  font-size: 36px;
  color: #7399c1;
  margin-top: 14px;
}
.active-bottom-menu div {
  width: 70px;
  height: 4px;
  background: #f39749;
  margin-top: 40px;
}

.active-bottom-rtop {
  display: flex;
}
.active-bottom-rtop div:nth-child(1) {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.active-bottom-rtop div:nth-child(1) p {
  font-size: 70px;
  color: #dedede;
}
.active-bottom-rtop div:nth-child(1) span {
  color: #999;
  font-size: 24px;
}
.active-bottom-rtop div:nth-child(2) {
  width: 8px;
  height: 130px;
  background: #dedede;
  margin-left: 30px;
  margin-right: 25px;
}

.active-bottom-rtop div:nth-child(3) {
  font-size: 22px;
  color: #0055d3;
}
.active-bottom-rmod {
  padding-top: 60px;
  padding-bottom: 40px;
}
.active-bottom-rbom {
  width: 100%;
  border-top: 1px solid #e6e6e6;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
}

.active-bottom-rbbox {
  display: flex;
  align-items: center;
}

.active-bottom-rbbox img {
  width: 13px;
  height: 23px;
  margin: 0 10px;
}

.active-bottom-rbbox div {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #aaa;
}
.active-bottom-rbbox div:hover {
  color: #0055d3;
  cursor: pointer;
}
.active-bottom-rbbox div p {
  margin-bottom: 4px;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.active-bottom-rmod img {
  width: 100%;
}

/* 新增样式 */
.active-bottom-rtop div:nth-child(3) {
  text-align: center;
  padding-top: 36px;
}
.active-bottom-rmod p {
  line-height: 35px;
}
.titleList {
  height: auto;
  width: auto;
  margin-left: 10px;
}
.title {
  display: flex;
  margin-left: 50px;
  width: auto;
  height: 85px;
}
.title:hover {
  background-color: #0055d3;
  color: #e6e6e6;
  cursor: pointer;
}
.title-left1 {
  color: #0055d3;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}
.title-left2 {
  color: #e6e6e6;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}
.title-right {
  height: auto;
  padding-top: 13px;
  margin-left: 12px;
  vertical-align: middle;
}
.title-title {
  font-size: 18px;
  font-weight: bold;
}

.title-brief {
  width:488px;
  font-size: 14px;
  white-space: nowrap;
  word-break: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}
.title-page {
  display: flex;
  justify-content: space-between;
  width: auto;
  padding: 0px 20px 0px 75px;
  margin: 90px 0px 70px;
}
.title-page .box {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-right: 2px;
  font-size: 16px;
  color: #333;
  background: #ddd;
}

.box:hover {
  cursor: pointer;
}

.title-page .flex {
  display: flex;
}

.title-page .active {
  color: #fff;
  background: #0055d3;
}

.title-page-active:active {
  background: #0055d3;
  color: #fff;
}
</style>